import React from "react";
import { Shell } from "@/components/Shell";
import { Link } from "react-router-dom";
import { useSiteAssets } from "@/lib/siteAssets";
import { imageUrl } from "@/components/ImageUpload";

export default function HowItWorks() {
    const assets = useSiteAssets();
    return (
        <Shell>
            <section className="section-pad">
                <div className="max-w-4xl mx-auto">
                    <div className="label-base">Playbook</div>
                    <h1 className="font-heading text-4xl md:text-6xl font-extrabold tracking-tight">How HealthFairX works.</h1>
                    <p className="mt-6 text-lg text-brand-mute max-w-2xl">A simple way to connect with qualified wellness vendors — without the back-and-forth.</p>

                    <div className="mt-10 rounded-3xl overflow-hidden border border-brand-line bg-white" data-testid="how-hero">
                        <img src={imageUrl(assets.howitworks_hero)} alt="" className="w-full h-[320px] md:h-[420px] object-cover" />
                    </div>

                    <div className="mt-12 space-y-12">
                        {[
                            { who: "Host company", color: "forest", body: "Tell us about your event — date, location, expected attendance, and the wellness services you're looking for. Our team reviews your requirements and prepares your event for qualified vendor matching. We notify vetted, matching vendors, and you choose who joins you. That's it." },
                            { who: "Vendor", color: "coral", body: "Set up your booth profile once. Choose the service categories you offer and the area you cover. We'll email you whenever a fitting event posts. Express interest in one click. If the host selects you, confirm your booth and you're in." },
                        ].map((b, i) => (
                            <div key={i} className="rounded-2xl border border-brand-line bg-white p-8">
                                <div className={`text-xs uppercase tracking-widest font-bold ${b.color === "coral" ? "text-brand-coral" : "text-brand-forest"} mb-2`}>{b.who}</div>
                                <p className="text-lg text-brand-ink leading-relaxed">{b.body}</p>
                            </div>
                        ))}
                    </div>

                    <div className="mt-16 flex flex-wrap gap-3">
                        <Link to="/register?role=host_company" className="pill btn-coral px-6 py-3 font-semibold">Host a fair</Link>
                        <Link to="/register?role=vendor" className="pill px-6 py-3 font-semibold border border-brand-line bg-white">Join as vendor</Link>
                    </div>
                </div>
            </section>
        </Shell>
    );
}
